import React from 'react'

export type Country = {
  name: string;
  slug: string;
  placeholder: string;
}

export type CountrySelectProps = {
  className?: string;
  label?: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  countries: Country[];
  required?: boolean;
}

export const CountrySelect = ({
  className,
  label,
  name,
  value,
  onChange,
  countries,
  required = false,
}: CountrySelectProps) => {
  return (
    <div className="flex flex-col mb-12">
      {label && <label htmlFor={name} className="text-base font-medium">{label}</label>}
      <select
        className={`${className}`}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
      >
        {countries.map((country) => (
          <option key={country.slug} value={country.slug}>
            {country.name}
          </option>
        ))}
      </select>
    </div>
  )
}

